import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, Input, ChangeDetectionStrategy } from '@angular/core';
import { ENGLISH_ID, SWEDISH_ID, FINNISH_ID, LanguageService, DANISH_ID } from '../../../core/service/language.service';

export enum OrientationType {
  horizontal = 1,
  vertical = 2,
}

@Component({
    selector: 'app-language',
    templateUrl: './language.component.html',
    styleUrls: ['./language.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LanguageComponent implements OnDestroy, OnInit {
  constructor(private _language: LanguageService) {
    this.languageChange = new EventEmitter<void>();
  }

  @Input() orientation: OrientationType;
  @Output() languageChange: EventEmitter<void>;

  private _languages = [
    { id: ENGLISH_ID, icon: 'icon-en', name: 'EN' },
    { id: SWEDISH_ID, icon: 'icon-se', name: 'SV' },
    { id: DANISH_ID, icon: 'icon-da', name: 'DA' },
    { id: FINNISH_ID, icon: 'icon-fi', name: 'FI' },
  ];
  get isHorizontal(): boolean {
    return this.orientation === OrientationType.horizontal;
  }
  itemsSource: { id: number; icon: string; name: string }[];
  selectedItem: { id: number; icon: string; name: string };

  ngOnDestroy() {}

  ngOnInit() {
    this.selectedItem = this._languages.find(x => x.id === this._language.currentLanguageId);
    if (this.orientation === OrientationType.vertical) {
      this.itemsSource = this._languages.filter(x => x.id !== this.selectedItem.id);
    } else {
      this.itemsSource = this._languages.slice();
    }
  }

  select(id: number) {
    this._language.setLanguage(id);
    this.selectedItem = this._languages.find(x => x.id === id);
    this.itemsSource = this._languages.filter(x => x.id !== id);
    this.languageChange.emit();
  }
}
